import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { FileText, Download } from 'lucide-react'

interface Resource {
  id: string
  title: string
  description: string
  type: string
  downloadUrl: string
}

interface ResourcesTabProps {
  resources: Resource[]
  className?: string
}

const ResourcesTab: React.FC<ResourcesTabProps> = ({ resources, className }) => {
  return (
    <div className={`space-y-6 ${className}`}>
      <div>
        <h3 className="text-lg font-semibold text-[var(--foreground)] mb-4">Partner Resources</h3>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {resources.map((resource) => (
            <Card key={resource.id} variant="elevated">
              <CardContent className="p-4">
                <div className="flex items-center gap-3 mb-2">
                  <FileText size={20} className="text-blue-400" />
                  <h4 className="font-medium text-[var(--foreground)]">{resource.title}</h4>
                </div>
                <p className="text-sm text-[var(--muted-foreground)] mb-3">{resource.description}</p>
                <Button variant="ghost" size="sm" className="flex items-center gap-2 p-0 h-auto">
                  <Download size={14} />
                  Download
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ResourcesTab 